//********************************************************************************
//* This file defines the Application Insights configuration for the application.
//* and global object to use when tracking events.
//********************************************************************************
import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import { createBrowserHistory } from "history";
import { getAppInsightInfo } from './authConfig';

const browserHistory = createBrowserHistory({ basename: "" });
const reactPlugin = new ReactPlugin();
let appInsights: ApplicationInsights;
getAppInsightInfo().then(appInsightInfo => {
  appInsights = new ApplicationInsights({
    config: {
      connectionString: appInsightInfo.CONNECTION_STRING,
      instrumentationKey: appInsightInfo.INSTRUMENTATION_KEY,
      maxAjaxCallsPerView: 1000,
      isBeaconApiDisabled: true,
      enableAutoRouteTracking: true,
      enableDebug: false, // Turn off debug to reduce noise
      disableFetchTracking: false, // Ensure fetch tracking is enabled
      disableAjaxTracking: false,   // Ensure AJAX tracking is enabled
      enableRequestHeaderTracking: false, // Reduce overhead
      enableResponseHeaderTracking: false, // Reduce overhead
      extensions: [reactPlugin],
      extensionConfig: {
        [reactPlugin.identifier]: { history: browserHistory },
      }
    },
  });
  // Add telemetry filter to reduce noise
  appInsights.addTelemetryInitializer((envelope) => {
    // Filter out certain problematic calls if needed
    if (envelope.baseData && envelope.baseData.target) {
      const url = envelope.baseData.target;
      // Skip tracking calls that consistently fail timing calculation
      if (url.includes('/api/Meters/Get') && url.includes('equipSerialInd=')) {
        return false; // Don't track this specific problematic call
      }
    }
    return true;
  });
  appInsights.loadAppInsights();
});
export { reactPlugin, appInsights };
